import React from 'react';
import CovidEndpage from './CovidEndpage';
import RebrandExistingUser from './RebrandExistingUser';
import RebrandEpForm from './RebrandEpForm';
import StandardEndpage from './StandardEndpage';

export type WeightedElement = {
  page: React.ReactElement;
  weight: number;
};

export const GUAC_EXISTING_USER_PAGES: WeightedElement[] = [
  { page: <CovidEndpage />, weight: 0.17 },
  { page: <RebrandExistingUser />, weight: 0.166 },
  { page: <StandardEndpage pageName="CxEndpage" utSource="survey-thanks" />, weight: 0.166 },
  { page: <StandardEndpage pageName="RacialJusticeEndpage" utSource="survey-thanks" />, weight: 0.166 },
  { page: <StandardEndpage pageName="CorporateSignatureResearchEndpage" utSource="survey-thanks" />, weight: 0.166 },
  { page: <StandardEndpage pageName="MrxEndpage" utSource="survey-thanks" />, weight: 0.166 },
];

export const US_GEO_PAGES: WeightedElement[] = [
  { page: <CovidEndpage />, weight: 0.4 },
  { page: <RebrandEpForm />, weight: 0.423 },
  { page: <StandardEndpage pageName="CxEndpage" utSource="survey-thanks" />, weight: 0.025 },
  { page: <StandardEndpage pageName="RacialJusticeEndpage" utSource="survey-thanks" />, weight: 0.021 },
  { page: <StandardEndpage pageName="CorporateSignatureResearchEndpage" utSource="survey-thanks" />, weight: 0.021 },
  { page: <StandardEndpage pageName="GiancarloEndpage" utSource="survey-thanks" />, weight: 0.11 },
];

export const GAC_GEO_PAGES: WeightedElement[] = [
  { page: <RebrandEpForm />, weight: 0.863 },
  { page: <StandardEndpage pageName="CxEndpage" utSource="survey-thanks" />, weight: 0.051 },
  { page: <StandardEndpage pageName="RacialJusticeEndpage" utSource="survey-thanks" />, weight: 0.043 },
  { page: <StandardEndpage pageName="CorporateSignatureResearchEndpage" utSource="survey-thanks" />, weight: 0.043 },
];
